import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import Select from 'react-select';
import lang from '../../constants/Languages.js';

const SearchFormField = ({ input, label, name, clang, options, isMainPage, isAllSearch, meta: { touched, error }}) => {
    const newOptions = options.map(option => { return {value: option.name, label: lang[clang].search.options[option.name] }})

    return (
        <div className={`search-bar__form-select ${isMainPage ? 'hidden' : ''}`}>
            <label className="search-bar__form-label">
                <Select {...input}
                    name={name}
                    className="search-bar__form-select-field"
                    clearable={false}
                    deleteRemoves={false}
                    backspaceRemoves={false}
                    searchable={false}
                    // disabled={isAllSearch}
                    options={newOptions}/>
            </label>
            {touched && (error &&
                <div className="search-bar__form-error">{lang[clang].validation[error]}</div>)}
        </div>
    );
};

SearchFormField.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SearchFormField);



// WEBPACK FOOTER //
// ./src/components/search/SearchFormSelect.js